const HELP_MODULES = [
  {
    key: 'dashboard',
    titleKey: 'MAIN.DASHBOARD',
    descriptionKey: 'HELP_CENTER.MODULES.DASHBOARD.DESCRIPTION',
    route: '/dashboard',
    routePrefixes: ['/dashboard'],
    icon: 'chart-pie',
    requiredPermission: 'dashboard.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="dashboard"]',
    sections: [
      'HELP_CENTER.MODULES.DASHBOARD.SECTIONS.READ_SIGNALS',
      'HELP_CENTER.MODULES.DASHBOARD.SECTIONS.FOLLOW_TRENDS',
      'HELP_CENTER.MODULES.DASHBOARD.SECTIONS.ACT_ON_INSIGHTS'
    ],
    tourSteps: [
      {
        target: '[data-tour="dashboard-header"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.HEADER_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.HEADER_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="dashboard-filters"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.FILTERS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="dashboard-insights"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.INSIGHTS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.INSIGHTS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="dashboard-metrics"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.METRICS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.METRICS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="dashboard-account-health"]',
        titleKey: 'HELP_CENTER.TOUR.DASHBOARD.ACCOUNT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.DASHBOARD.ACCOUNT_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'questions',
    titleKey: 'MAIN.QUESTIONS',
    descriptionKey: 'HELP_CENTER.MODULES.QUESTIONS.DESCRIPTION',
    route: '/questions',
    routePrefixes: ['/questions'],
    icon: 'question-circle',
    requiredPermission: 'questions.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="questions"]',
    sections: [
      'HELP_CENTER.MODULES.QUESTIONS.SECTIONS.REVIEW_PENDING',
      'HELP_CENTER.MODULES.QUESTIONS.SECTIONS.ANSWER_INLINE',
      'HELP_CENTER.MODULES.QUESTIONS.SECTIONS.USE_CONTEXT'
    ],
    tourSteps: [
      {
        target: '[data-tour="questions-tabs"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.TABS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.TABS_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="questions-unanswered-list"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.UNANSWERED_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.UNANSWERED_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="questions-first-card"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.CARD_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.CARD_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="questions-card-actions"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.ACTIONS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.ACTIONS_CONTENT',
        placement: 'left'
      },
      {
        target: '[data-tour="questions-all-filters"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.FILTERS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="questions-table-question"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="questions-table-actions"]',
        titleKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_ACTIONS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.QUESTIONS.TABLE_ACTIONS_CONTENT',
        placement: 'left'
      }
    ]
  },
  {
    key: 'messages',
    titleKey: 'MAIN.MESSAGES',
    descriptionKey: 'HELP_CENTER.MODULES.MESSAGES.DESCRIPTION',
    route: '/messages',
    routePrefixes: ['/messages', '/mercadolibre-messages'],
    icon: 'comments',
    requiredAnyPermissions: ['messages.view_internal', 'messages.view_mercadolibre'],
    modes: ['gestion'],
    sections: [
      'HELP_CENTER.MODULES.MESSAGES.SECTIONS.OPEN_INBOX',
      'HELP_CENTER.MODULES.MESSAGES.SECTIONS.TRACK_CONVERSATIONS',
      'HELP_CENTER.MODULES.MESSAGES.SECTIONS.REPLY_WITH_CONTEXT'
    ]
  },
  {
    key: 'sales',
    titleKey: 'MAIN.SALES',
    descriptionKey: 'HELP_CENTER.MODULES.SALES.DESCRIPTION',
    route: '/sales',
    routePrefixes: ['/sales'],
    icon: 'shopping-cart',
    requiredPermission: 'sales.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="sales"]',
    sections: [
      'HELP_CENTER.MODULES.SALES.SECTIONS.REVIEW_ORDERS',
      'HELP_CENTER.MODULES.SALES.SECTIONS.CHECK_ATTRIBUTION',
      'HELP_CENTER.MODULES.SALES.SECTIONS.FOLLOW_POSTSALE'
    ],
    tourSteps: [
      {
        target: '[data-tour="sales-period-filters"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.FILTERS_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="sales-list-controls"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.SEARCH_SORT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.SEARCH_SORT_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-order-id"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.ORDER_ID_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.ORDER_ID_CONTENT',
        placement: 'right'
      },
      {
        target: '[data-tour="sales-order-items"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.ITEMS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.ITEMS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-payment-status"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.PAYMENT_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.PAYMENT_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-shipping-status"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.SHIPPING_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.SHIPPING_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="sales-attribution"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.ATTRIBUTION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.ATTRIBUTION_CONTENT',
        placement: 'left'
      },
      {
        target: '[data-tour="sales-pagination"]',
        titleKey: 'HELP_CENTER.TOUR.SALES.PAGINATION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.SALES.PAGINATION_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'posts',
    titleKey: 'MAIN.POSTS',
    descriptionKey: 'HELP_CENTER.MODULES.POSTS.DESCRIPTION',
    route: '/posts',
    routePrefixes: ['/posts'],
    icon: 'file-invoice',
    requiredPermission: 'posts.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="posts"]',
    sections: [
      'HELP_CENTER.MODULES.POSTS.SECTIONS.REVIEW_LISTINGS',
      'HELP_CENTER.MODULES.POSTS.SECTIONS.EDIT_DETAILS',
      'HELP_CENTER.MODULES.POSTS.SECTIONS.TUNE_AUTOMATION'
    ],
    tourSteps: [
      {
        target: '[data-tour="posts-filters"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.FILTERS_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="posts-results"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.RESULTS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.RESULTS_CONTENT',
        placement: 'top'
      },
      {
        target: '[data-tour="posts-list-table"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.TABLE_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.TABLE_CONTENT',
        placement: 'top'
      },
      {
        target: '[data-tour="posts-first-grid-card"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.CARD_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.CARD_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="posts-pagination"]',
        titleKey: 'HELP_CENTER.TOUR.POSTS.PAGINATION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.POSTS.PAGINATION_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'stock',
    titleKey: 'MAIN.STOCK',
    descriptionKey: 'HELP_CENTER.MODULES.STOCK.DESCRIPTION',
    route: '/stock',
    routePrefixes: ['/stock'],
    icon: 'box',
    requiredPermission: 'stock.view',
    modes: ['gestion'],
    tourReadySelector: '[data-tour-ready="stock"]',
    sections: [
      'HELP_CENTER.MODULES.STOCK.SECTIONS.MONITOR_LEVELS',
      'HELP_CENTER.MODULES.STOCK.SECTIONS.PRIORITIZE_ALERTS',
      'HELP_CENTER.MODULES.STOCK.SECTIONS.OPEN_LISTINGS'
    ],
    tourSteps: [
      {
        target: '[data-tour="stock-filters"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.FILTERS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.FILTERS_CONTENT',
        placement: 'bottom',
        skipBeacon: true
      },
      {
        target: '[data-tour="stock-first-publication"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.PUBLICATION_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.PUBLICATION_CONTENT',
        placement: 'right'
      },
      {
        target: '[data-tour="stock-first-quantity"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.QUANTITY_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.QUANTITY_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="stock-first-locations"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.LOCATIONS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.LOCATIONS_CONTENT',
        placement: 'bottom'
      },
      {
        target: '[data-tour="stock-first-threshold"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLD_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLD_CONTENT',
        placement: 'left'
      },
      {
        target: '[data-tour="stock-thresholds"]',
        titleKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLDS_TITLE',
        contentKey: 'HELP_CENTER.TOUR.STOCK.THRESHOLDS_CONTENT',
        placement: 'top'
      }
    ]
  },
  {
    key: 'integrations',
    titleKey: 'MAIN.INTEGRATIONS',
    descriptionKey: 'HELP_CENTER.MODULES.INTEGRATIONS.DESCRIPTION',
    route: '/integrations',
    routePrefixes: ['/integrations'],
    icon: 'plug',
    requiredPermission: 'integrations.view',
    modes: ['gestion'],
    sections: [
      'HELP_CENTER.MODULES.INTEGRATIONS.SECTIONS.CONNECT_ACCOUNT',
      'HELP_CENTER.MODULES.INTEGRATIONS.SECTIONS.SWITCH_CONTEXT',
      'HELP_CENTER.MODULES.INTEGRATIONS.SECTIONS.CHECK_STATUS'
    ]
  },
  {
    key: 'agents',
    titleKey: 'MAIN.AGENTS',
    descriptionKey: 'HELP_CENTER.MODULES.AGENTS.DESCRIPTION',
    route: '/agents',
    routePrefixes: ['/agents'],
    icon: 'robot',
    requiredPermission: 'agents.view',
    modes: ['gestion'],
    sections: [
      'HELP_CENTER.MODULES.AGENTS.SECTIONS.CHOOSE_AGENT',
      'HELP_CENTER.MODULES.AGENTS.SECTIONS.CONFIGURE_BEHAVIOR',
      'HELP_CENTER.MODULES.AGENTS.SECTIONS.TEST_BEFORE_LIVE'
    ]
  },
  {
    key: 'access',
    titleKey: 'MAIN.ACCESS',
    descriptionKey: 'HELP_CENTER.MODULES.ACCESS.DESCRIPTION',
    route: '/users',
    routePrefixes: ['/users', '/profiles', '/activity'],
    icon: 'users',
    requiredAnyPermissions: ['users.view', 'profiles.view', 'activity.view'],
    modes: ['gestion'],
    sections: [
      'HELP_CENTER.MODULES.ACCESS.SECTIONS.INVITE_USERS',
      'HELP_CENTER.MODULES.ACCESS.SECTIONS.ASSIGN_PROFILES',
      'HELP_CENTER.MODULES.ACCESS.SECTIONS.AUDIT_ACTIVITY'
    ]
  },
  {
    key: 'sales_workspace',
    titleKey: 'SALES.MENU',
    descriptionKey: 'HELP_CENTER.MODULES.SALES_WORKSPACE.DESCRIPTION',
    route: '/sales/dashboard',
    routePrefixes: ['/sales/dashboard', '/sales/pipeline', '/sales/tasks', '/sales/accounts-to-activate', '/sales/promo', '/sales/reports', '/sales/waitlist', '/sales/companies', '/sales/company', '/sales/opportunity'],
    icon: 'chart-line',
    requiredAnyPermissions: ['crm.view', 'pipeline.view', 'tasks.view', 'waitlist.view', 'sales_reports.view', 'promo.view'],
    modes: ['sales'],
    sections: [
      'HELP_CENTER.MODULES.SALES_WORKSPACE.SECTIONS.REVIEW_DASHBOARD',
      'HELP_CENTER.MODULES.SALES_WORKSPACE.SECTIONS.MOVE_PIPELINE',
      'HELP_CENTER.MODULES.SALES_WORKSPACE.SECTIONS.COMPLETE_TASKS'
    ]
  }
];

const hasAccessToHelpModule = (module, auth) => {
  if (module.requiresSuperAdmin && !auth.isSuperAdmin()) {
    return false;
  }
  if (Array.isArray(module.modes) && module.modes.length && !module.modes.includes(auth.getCurrentWorkspaceMode())) {
    return false;
  }
  if (module.requiredPermission && !auth.hasPermission(module.requiredPermission)) {
    return false;
  }
  if (module.requiredAnyPermissions && !auth.hasAnyPermission(module.requiredAnyPermissions)) {
    return false;
  }
  return true;
};

const getVisibleHelpModules = auth =>
  HELP_MODULES.filter(module => hasAccessToHelpModule(module, auth));

const getHelpModulesForMode = auth =>
  HELP_MODULES.filter(module => {
    if (module.requiresSuperAdmin && !auth.isSuperAdmin()) {
      return false;
    }
    return !Array.isArray(module.modes) ||
      !module.modes.length ||
      module.modes.includes(auth.getCurrentWorkspaceMode());
  });

const getHelpModulesWithAccess = auth =>
  getHelpModulesForMode(auth).map(module => ({
    ...module,
    hasAccess: hasAccessToHelpModule(module, auth)
  }));

const findHelpModuleByKey = key =>
  HELP_MODULES.find(module => module.key === key);

const findHelpModuleByPath = pathname => {
  const matches = HELP_MODULES
    .flatMap(module =>
      module.routePrefixes
        .filter(prefix => pathname === prefix || pathname.startsWith(`${prefix}/`))
        .map(prefix => ({ module, prefix }))
    )
    .sort((a, b) => b.prefix.length - a.prefix.length);

  return matches[0]?.module;
};

const buildModuleTourSteps = (t, module) =>
  (module.tourSteps || []).map(step => ({
    ...step,
    title: t(step.titleKey),
    content: t(step.contentKey)
  }));

const buildHelpManualTourSteps = (t, module) => [
  {
    target: '[data-tour="help-featured-module"]',
    title: t('HELP_CENTER.TOUR.MANUAL_TITLE', { module: t(module.titleKey) }),
    content: t('HELP_CENTER.TOUR.MANUAL_CONTENT'),
    placement: 'bottom',
    skipBeacon: true
  },
  {
    target: '[data-tour="help-module-list"]',
    title: t('HELP_CENTER.TOUR.MODULE_LIST_TITLE'),
    content: t('HELP_CENTER.TOUR.MODULE_LIST_CONTENT'),
    placement: 'top'
  },
  {
    target: '[data-tour="top-actions"]',
    title: t('HELP_CENTER.TOUR.HELP_ACTIONS_TITLE'),
    content: t('HELP_CENTER.TOUR.HELP_ACTIONS_CONTENT'),
    placement: 'bottom-end'
  }
];

export {
  HELP_MODULES,
  buildHelpManualTourSteps,
  buildModuleTourSteps,
  findHelpModuleByKey,
  findHelpModuleByPath,
  getHelpModulesForMode,
  getHelpModulesWithAccess,
  getVisibleHelpModules,
  hasAccessToHelpModule
};
